import "./News.module.css";
import Header from "@/reusable_sections/Header";
import RecentPosts from "./sections/RecentPosts";
import VisualShowcase from "./sections/VisualShowcase";
import GetAFreeQuote from "./sections/GetAFreeQuote";
import Footer from "@/reusable_sections/Footer";
export default function NewsPage() {
  return <div>
      <Header />
      <RecentPosts />
      <VisualShowcase />
      <GetAFreeQuote />
      <Footer />
    </div>;
}